import { observer } from 'mobx-react';
import React, { useCallback, useMemo } from 'react';
import { deliveryTypeStore } from '../../store/deliveryTypeStore';
import { DELIVERY_TYPE } from 'src/constants/deliveryTypes';
import { ICustomerAddress } from 'src/types/user';
import './style.scss';

interface IProps {
  address?: ICustomerAddress;
}

const SidebarAddress: React.FC<IProps> = observer((props: IProps): JSX.Element | null => {
  const selectAddress = useCallback(() => {
    deliveryTypeStore.getDeliveryDependencies(props.address?.lat || 0, props.address?.lng || 0, props.address?.id);
  }, [props.address]);

  const wrapperClassName = useMemo((): string => {
    let className: string = 'sidebar-address d-flex flex-column full-width bg_hover-graysoft bg_active-bluelight';

    if (deliveryTypeStore.selectedDeliveryState[DELIVERY_TYPE.DELIVERY].location?.customer_location_id === props.address?.id) className += ' active';

    return className;
  }, [props.address, deliveryTypeStore.selectedDeliveryState[DELIVERY_TYPE.DELIVERY].location]);

  if (!props.address) return null;

  return (
    <div onClick={selectAddress} className={wrapperClassName}>
      <p className="sidebar-address__title">{props.address?.address}</p>
    </div>
  );
});

export default SidebarAddress;
